import { useState, useEffect } from 'react';
import axios from 'axios';
import { User } from '../types';

const API_BASE = process.env.REACT_APP_API_URL || 'https://api.claudevietnam.com';

export function useAuth() {
  const [user, setUser] = useState<User | null>(null);
  const [token, setToken] = useState<string | null>(localStorage.getItem('auth_token'));
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (token) {
      localStorage.setItem('auth_token', token);
    } else {
      localStorage.removeItem('auth_token');
    }
  }, [token]);

  const register = async (email: string, username: string, password: string) => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.post(`${API_BASE}/api/auth/register`, {
        email,
        username,
        password,
      });
      setToken(response.data.token);
      setUser({ id: response.data.user_id, email, username });
      return response.data;
    } catch (err: any) {
      const msg = err.response?.data?.error || 'Registration failed';
      setError(msg);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const login = async (email: string, password: string) => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.post(`${API_BASE}/api/auth/login`, {
        email,
        password,
      });
      setToken(response.data.token);
      setUser({ id: response.data.user_id, email, username: response.data.username });
      return response.data;
    } catch (err: any) {
      const msg = err.response?.data?.error || 'Login failed';
      setError(msg);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    setToken(null);
    setUser(null);
    localStorage.removeItem('auth_token');
  };

  return { user, token, loading, error, register, login, logout };
}
